module.exports = require('./lib/emoji');


//////////////////
// WEBPACK FOOTER
// ../~/node-emoji/index.js
// module id = ../node_modules/node-emoji/index.js
// module chunks = 0